

import React from 'react';
import {
  Table,
  Box,
  Button,
  Header,
  Pagination,
  CollectionPreferences,
  SpaceBetween
} from '@amzn/awsui-components-react/polaris';
import { useGeoJsonStore } from '../../../../store/GeojsonStore';
import { GeoJsonTableViewRow } from '../../../../store/models/GeojsonStore';

const GeoJsonTableView = () => {
  const setSelection = useGeoJsonStore((state) => state.setSelection);
  const settings = useGeoJsonStore((state) => state.settings);
  const clearSelection = useGeoJsonStore((state) => state.clearSelection);
  const deleteSelection = useGeoJsonStore((state) => state.deleteSelection);
  
  const onClearSelectionClicked = () => {
    clearSelection();
  };

  const onDeleteSelectedClicked = () => {
    deleteSelection();
  };

  const onSelectionChange = ( { detail }: any) => {
    if (detail.selectedItems.length > 0) {
      setSelection(detail.selectedItems[0].featureId);
    } else {
      setSelection(null);
    }
  };

  const getSelection = (): Array<{ featureId: number }> => {
    if (settings.selectedFeature === null) {
      return [];
    }
    return [{ featureId: settings.selectedFeature }]
  };

  return (
    <Table
      onSelectionChange={onSelectionChange}
      selectedItems={getSelection()}
      columnDefinitions={[
        {
          id: 'featureId',
          header: 'FeatureId',
          cell: (e: GeoJsonTableViewRow) => e.featureId,
          sortingField: 'featureId'
        },
        {
          id: 'geometryType',
          header: 'Geometry',
          cell: (e: GeoJsonTableViewRow) => e.geometryType,
          sortingField: 'geometryType'
        },
      ]}
      items={settings.tableViewData}
      loadingText='Loading resources'
      selectionType='single'
      trackBy='featureId'
      visibleColumns={[
        'featureId',
        'geometryType',
      ]}
      empty={
        <Box textAlign='center' color='inherit'>
          <b>No features to display.</b>
        </Box>
      }
      header={
        <Header>
          <Box float='right'>
            <SpaceBetween direction='horizontal' size='xs'>
              {(settings.selectedFeature !== null) && <Button
                onClick={onClearSelectionClicked}>
                Clear Selection
              </Button>
              }

              {(settings.selectedFeature !== null) && <Button
                onClick={onDeleteSelectedClicked}>
                Delete Seleted Feature
              </Button>
              }
            </SpaceBetween>
          </Box>
        </Header>
      }
      pagination={
        <>
          <Pagination
            currentPageIndex={1}
            pagesCount={2}
            ariaLabels={{
              nextPageLabel: 'Next page',
              previousPageLabel: 'Previous page',
              pageLabel: pageNumber =>
                `Page ${pageNumber} of all pages`
            }}
          />
        </>
      }
      preferences={
        <CollectionPreferences
          title='Preferences'
          confirmLabel='Confirm'
          cancelLabel='Cancel'
          preferences={{
            pageSize: 10,
            visibleContent: [
              'featureId',
              'geometryType',
            ]
          }}
          pageSizePreference={{
            title: 'Select page size',
            options: [
              { value: 10, label: '10 resources' },
              { value: 20, label: '20 resources' }
            ]
          }}
          visibleContentPreference={{
            title: 'Select visible content',
            options: [
              {
                label: 'Main distribution properties',
                options: [
                  {
                    id: 'featureId',
                    label: 'FeatureId',
                    editable: false
                  },
                  { id: 'geometryType', label: 'Geometry' },
                ]
              }
            ]
          }}
        />
      }
    />
  );
}


export default GeoJsonTableView;